import React, { useState } from 'react'

function Questioncontent1({ onNext,  }) {
  
  const [isChecked, setIsChecked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false); 
  const [errorMessage, setErrorMessage] = useState(null); 

  // Handle the checkbox change
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked); 
  };

  // Handle the Next button click
  const handleNextClick = async () => {
    if (!isChecked) {
      setIsError(true); 
      return; 
    }
    setLoading(true); 
    setErrorMessage(null); 
    const data = {}
    
    onNext({data})

  };

  return (
    <div className='r-content'>
      <h4 className='content-title'>Safe Use of the Application:</h4>
      <p className='content-text'>
        Ensure your identity remains protected by avoiding sharing personal information in forms or attachments.
        Use a secure internet connection with a lock symbol in your browser. Access the application or your mailbox
        only through a private device. Trusty AG, the developer, ensures no IP addresses are recorded and only uses
        temporary cookies for security. All communication is encrypted.
      </p>
      <br />
      <h4 className='content-title'>Safe Use of the Application:</h4>
      <div className="content-text">
        The Olympic Committee of Slovenia manages all personal data transmitted through the application.
      </div>
      <button className='content-moredetails'>More Details</button>
      <form method='POST' className='agreement'>
        <label className={`check-agreement ${isError ? 'error' : ''}`}>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            id="agreementscheckbox"
          />
          I confirm that I have read and understood the confidentiality notices
        </label>
      </form>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      <div className='back-next'>
        {/* <button className='Backbtn' onClick={onBack}>Back</button> */}
        <button className='Nextbtn' onClick={handleNextClick} >
          next
        </button>
      </div>
    </div>
  );
}

export default Questioncontent1;
